<div class="row">
  <div class="col-md-12">
    <div class="heading">
      <p class="addressStyle" *ngIf="listingDetails?.property_address">
        {{ listingDetails?.property_address }}
      </p>
      <button class="pencil-setting" (click)="adminView()" *ngIf="is_agentModel">Admin View</button>
    </div>

    <div class="divShadow">
      <div class="main-image-box">
        <div class="position-absolute">
          <p class="statusStyle">{{ dayAgo(listingDetails?.created_at) }}</p>
          <p class="statusStyle1" *ngIf="listingDetails?.property_status">
            {{ listingDetails?.property_status }}
          </p>
        </div>

        <p class="statusStyle2" hoverHighlightInfo id="listing-image-index">
          {{ currentIndex ? currentIndex + 1 : 1 }} of
          {{ listingDetails?.property_images?.length }}
        </p>

        <!-- Sizes used to come from the splitter panel's width. That splitter is gone, so the
             images keep their own aspect ratio instead of a number left over from it. -->
        <ng-container *ngIf="imagesPath">
          <img src="{{ S3Path + imagesPath }}" alt="" class="main-images" id="imageId" />
        </ng-container>

        <ng-container *ngIf="!imagesPath">
          <ng-container *ngIf="listingDetails?.property_images?.length > 0; else elsePart">
            <img [src]="getImageByPath(listingDetails?.property_images[0])" alt="" class="main-images" />
          </ng-container>

          <ng-template #elsePart>
            <img [src]="common_images?.image_not_found" class="elsePart" />
          </ng-template>
        </ng-container>
      </div>

      <div class="carousel-image-box">
        <button class="carousel-prev" *ngIf="displayedImages?.length > 1" (click)="goToPrevious()">
          <i class="pi pi-chevron-up f-12"></i>
        </button>
        <ng-container *ngFor="let image of displayedImages">
          <img [src]="getSliderImageByPath(image)" (click)="getImagePath(image)" class="carousel-image" />
        </ng-container>
        <button class="carousel-next" *ngIf="displayedImages?.length > 1" (click)="goToNext()">
          <i class="pi pi-chevron-down f-12"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="col-md-6">
    <ul class="sale_type">
      <li class="pt-0">
        <p class="sale_type_text">Sale Type</p>
        <p class="sale_type_value">{{ listingDetails?.property_status }}</p>
      </li>

      <li>
        <p class="sale_type_text">
          <img [src]="common_images?.tag_one_icon" width="18" alt="" />
          Price
        </p>

        <p class="sale_type_text_two">
          <ng-container *ngIf="getDisplayPrice().isCurrency; else plainText">
            {{ getDisplayPrice().value | customCurrency }}
          </ng-container>

          <ng-template #plainText>
            {{ getDisplayPrice().value }}
          </ng-template>
        </p>
      </li>

      <li *ngIf="listingDetails?.beds">
        <p class="sale_type_text">
          <img [src]="common_images?.single_bed_icon" width="18" alt="" />
          Bedroom
        </p>

        <p class="sale_type_text_two">
          {{ listingDetails.beds }}
        </p>
      </li>

      <li *ngIf="listingDetails?.baths">
        <p class="sale_type_text">
          <img [src]="common_images?.cil_bathroom_icon" width="18" alt="" />
          Bathroom
        </p>

        <p class="sale_type_text_two">
          {{ listingDetails.baths }}
        </p>
      </li>

      <li *ngIf="getTotalCarSpaces() > 0">
        <p class="sale_type_text">
          <img [src]="common_images?.garage_icon" width="18" alt="" />
          Car Spaces
        </p>

        <p class="sale_type_text_two">
          {{ getTotalCarSpaces() }}
        </p>
      </li>

      <li *ngIf="listingDetails?.land_area">
        <p class="sale_type_text">
          <img [src]="common_images?.area_1_icon" width="18" alt="" />
          Land Size
        </p>

        <p class="sale_type_text_two">
          {{ getLandAreaDisplay() }}
        </p>
      </li>

      <li *ngIf="listingDetails?.building_area">
        <p class="sale_type_text">
          <img [src]="common_images?.house_plan_icon" width="18" alt="" />
          House Size
        </p>

        <p class="sale_type_text_two">
          {{ getBuildingAreaDisplay() }}
        </p>
      </li>
    </ul>
  </div>

  <div class="col-md-6">
    <div class="schedule-section pt-0">
      <!-- Auctions -->
      <div class="schedule-card" *ngIf="listingDetails?.date">
        <div class="card-title">Auctions</div>

        <div class="schedule-row">
          <span>{{ listingDetails?.date | date: 'EE d MMM y' }}</span>
          <span>&#64; {{ getTimed(listingDetails?.startTime) }}</span>
        </div>
      </div>

      <!-- Inspections -->
      <div class="schedule-card">
        <div class="card-title">Inspections</div>
        <ng-container *ngIf="listingDetails?.appointments_and_inspections?.length > 0; else noInspections">
          <ng-container *ngFor="let inspection of listingDetails?.appointments_and_inspections">
            <div class="schedule-row">
              <span>{{ inspection.event.start.dateTime | wallClock | date: 'EEEE, d MMM y' }}</span>
              <span>{{ inspection.start_time }} - {{ inspection.end_time }}</span>
            </div>
          </ng-container>
        </ng-container>
        <ng-template #noInspections>
          <div class="schedule-row">
            <span>No upcoming inspections</span>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="col-md-12 mt-3">
    <hr class="my-0 mr-2" />
  </div>

  <div class="col-md-12">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div class="agentDetail">
            <ng-container *ngIf="hasAnyAgent(); else noAgent">
              <!-- Primary Agent -->
              <div class="pricingDetail" *ngIf="listingDetails?.agent">
                <div class="profile_box">
                  <ng-container
                    *ngTemplateOutlet="
                      agentTemplate;
                      context: {
                        agent: listingDetails.agent,
                        role: 'Primary Agent',
                      }
                    ">
                  </ng-container>
                </div>
              </div>

              <!-- Secondary Agent -->
              <div class="pricingDetail" *ngIf="listingDetails?.secondaryagent">
                <div class="profile_box">
                  <ng-container
                    *ngTemplateOutlet="
                      agentTemplate;
                      context: {
                        agent: listingDetails.secondaryagent,
                        role: 'Secondary Agent',
                      }
                    ">
                  </ng-container>
                </div>
              </div>
            </ng-container>

            <ng-template #noAgent>
              <div class="pricingDetail border-bottom-0 col-sm-6">
                <p>No agent selected for this listing</p>
              </div>
            </ng-template>

            <!-- Other Agents -->
            <ng-container *ngIf="listingDetails?.other_agents?.length > 0">
              <div class="pricingDetail" *ngFor="let agent of listingDetails.other_agents">
                <div class="profile_box">
                  <ng-container
                    *ngTemplateOutlet="
                      agentTemplate;
                      context: {
                        agent: agent,
                        role: 'Agent',
                      }
                    ">
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- 🔥 Reusable Agent Template -->
    <ng-template #agentTemplate let-agent="agent" let-role="role">
      <span *ngIf="agent?.photo; else initialsTemplate">
        <img [src]="S3Path + agent.photo" alt="Agent" class="agent-title" width="40" />
      </span>

      <ng-template #initialsTemplate>
        <p class="agent-title f-18" [title]="agent?.full_name">{{ agent?.first_name?.charAt(0) }}{{ agent?.last_name?.charAt(0) }}</p>
      </ng-template>

      <div class="ml-2">
        <p class="agent_title">
          {{ agent?.full_name }}
        </p>
        <p class="agent_role">{{ role }}</p>
      </div>
    </ng-template>
  </div>

  <div class="col-md-12">
    <hr class="my-0 mr-2" />
  </div>

  <div class="col-md-12 description-section mt-3">
    <ng-container *ngIf="listingDetails?.heading || listingDetails?.description_garax">
      <p class="description">Description</p>

      <p class="heading">
        {{ listingDetails?.heading }}
      </p>

      <p class="description-text" [innerHTML]="descriptionContent"></p>

      <button *ngIf="isLongDescription" class="read-more" (click)="toggleDescription()">
        {{ isExpanded ? 'Read Less' : 'Read More' }}
      </button>
    </ng-container>
  </div>

  <div class="col-md-12 mt-3" *ngIf="listingDetails?.heading || listingDetails?.description_garax">
    <hr class="my-0 mr-2" />
  </div>

  <div class="col-md-12">
    <div class="features-section" *ngIf="listingDetails?.features?.length">
      <h3 class="section-title">Features</h3>

      <ul class="features-grid">
        <li class="feature-item" *ngFor="let item of listingDetails.features">
          <i class="pi pi-check feature-icon"></i>
          <span>{{ item }}</span>
        </li>
      </ul>
    </div>
  </div>
</div>
